/* useToast — thin wrapper over notistack (PS.toast equivalent).
   const toast = useToast(); toast('Saved', 'success').
   Variants: 'success' | 'error' | 'warning' | 'info' | 'default'. */
import {useCallback} from 'react'
import {useSnackbar} from 'notistack'

export default function useToast() {
  const {enqueueSnackbar} = useSnackbar()
  return useCallback(
    (message, variant = 'info') => enqueueSnackbar(message, {variant}),
    [enqueueSnackbar]
  )
}
